import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import ImpactHero, { heroImgStyles } from '~components/ImpactHero';
import Infographic from '~components/Infographic';

// Page Navigation
import PageNav from '~components/PageNav';
import ResearchCard from '~components/PageCard/ResearchCard';
import VirtualFundraisingCard from '~components/PageCard/FundraisingCard';

import RoundTable from '~components/Svg/RoundTable';
import HandshakeSquare from '~components/Svg/HandshakeSquare';
import Tester from '~components/Svg/Tester';
import DocumentCheck from '~components/Svg/DocumentCheck';
import Government from '~components/Svg/Government';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Défense d’intérêts" desc="Description" />
      <ImpactHero title="Défense d’intérêts">
        <StaticImage style={heroImgStyles} src="../../images/advocacy.jpg" alt="" />
      </ImpactHero>
      <div tw="container">
        <div tw="grid gap-12 my-12 md:(gap-24 grid-cols-2)">
          <Infographic icon={<RoundTable tw="text-blue h-36 w-auto" />} title="85">
          85 bénévoles, dont des jeunes délégués et des parents, ont participé à l'événement « Les enfants pour une guérison » de 2020. Les délégués ont rencontré virtuellement des membres du Parlement et des sénateurs, afin de les sensibiliser aux défis quotidiens du DT1.
          </Infographic>
          <Infographic icon={<HandshakeSquare tw="text-blue h-36 w-auto" />} title="90">
          90 membres du Parlement ont participé à 77 réunions en ligne
          </Infographic>
        </div>
      </div>
      <div tw="py-12 bg-blue text-white">
        <div tw="container">
          <div tw="grid gap-12 my-12 items-end md:(gap-24 grid-cols-2)">
            <Infographic icon={<Tester tw="text-white h-36 w-auto" />} title="35+">
            Plus de 35 réunions #AccèsPourTous dans tout le pays entre nos défenseurs et leurs représentants provinciaux pour exiger des technologies abordables et accessibles pour toute personne vivant avec le DT1
            </Infographic>
            <Infographic icon={<DocumentCheck tw="text-white h-36 w-auto" />} title="400+">
            Plus de 400 courriels de plaidoyer adressés aux représentants provinciaux pour augmenter les couvertures publiques et privées des pompes à insuline et des moniteurs de glucose avancés (CGM et Flash GM) afin de réduire les coûts de ces technologies et d'en améliorer l'accès pour les Canadiens atteints du DT1.
            </Infographic>
          </div>
        </div>
      </div>
      <div tw="container">
        <div tw="grid gap-12 my-12 items-end md:(gap-24 grid-cols-2)">
          <Infographic icon={<Government tw="text-blue h-36 w-auto" />} title="Jusqu'à 15,000 $">
          Jusqu'à 15 000 $ de frais remboursables annuels dépensés par un Canadien pour gérer son DT1. FRDJ continue de défendre les intérêts des Canadiens atteints du diabète de type 1 afin d'obtenir une aide financière indispensable, par le biais de politiques et de programmes favorisant l'accès aux thérapies vitales dont ils ont besoin.
          </Infographic>
        </div>
        <PageNav previous={<ResearchCard />} next={<VirtualFundraisingCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
